import { FC } from 'react';

import { Image, useUserColorMode } from '@bonusly/design-system';

import snappyLogoDark from '../../../assets/images/snappy-logo-alt-dark.png';
import snappyLogoAlt from '../../../assets/images/snappy-logo-alt.png';
import snappyLogoDefaultDark from '../../../assets/images/snappy-logo-dark.png';
import snappyLogoDefault from '../../../assets/images/snappy-logo.png';

export type SnappyLogoVariant = 'default' | 'alt';

interface SnappyLogoProps {
	/**
	 * `default` — the standalone "snappy" wordmark + icon (used on the order
	 * confirmation screen). `alt` — the smaller "POWERED BY snappy" lockup
	 * (used in redemption history).
	 */
	variant?: SnappyLogoVariant;
	alt?: string;
}

const LOGOS: Record<SnappyLogoVariant, { light: string; dark: string }> = {
	default: { light: snappyLogoDefault, dark: snappyLogoDefaultDark },
	alt: { light: snappyLogoAlt, dark: snappyLogoDark },
};

export const SnappyLogo: FC<SnappyLogoProps> = ({ variant = 'default', alt = 'Snappy logo' }) => {
	const { isDarkMode } = useUserColorMode();
	const { light, dark } = LOGOS[variant];

	return <Image src={isDarkMode ? dark : light} alt={alt} />;
};
